var _rect, _rect2, _rect3, _text, _text2, _text3, _rect4, _path, _path2, _rect5, _text4, _rect6, _rect7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerdantLiving(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 750",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 750,
    fill: "#dce8e1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 70,
    width: 1060,
    height: 610,
    rx: 26,
    fill: "#f7fbf5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 70,
    width: 1060,
    height: 82,
    rx: 26,
    fill: "#315f50"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 122,
    fontFamily: "Arial",
    fontSize: 28,
    fontWeight: 700,
    fill: "#fff"
  }, "VERDANT LIVING")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 250,
    fontFamily: "Arial",
    fontSize: 62,
    fontWeight: 700,
    fill: "#214637"
  }, "Daily wellness, naturally.")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 300,
    fontFamily: "Arial",
    fontSize: 23,
    fill: "#657d70"
  }, "Thoughtful products for a greener routine.")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 770,
    y: 220,
    width: 250,
    height: 260,
    rx: 125,
    fill: "#bed9a9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M895 430c-80-75-90-160 0-230 90 70 80 155 0 230Z",
    fill: "#568b59"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M895 430V230M895 330l-65-65M895 365l70-74",
    stroke: "#dff0d7",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 420,
    width: 260,
    height: 64,
    rx: 32,
    fill: "#d17b46"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 183,
    y: 460,
    fontFamily: "Arial",
    fontSize: 20,
    fontWeight: 700,
    fill: "#fff"
  }, "Shop naturally")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 545,
    width: 220,
    height: 55,
    rx: 12,
    fill: "#e2eee1"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 370,
    y: 545,
    width: 220,
    height: 55,
    rx: 12,
    fill: "#e2eee1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerdantLiving);
export default __webpack_public_path__ + "static/media/verdant-living.c509e78484820d11bc3f51093f6894e0.svg";
export { ForwardRef as ReactComponent };